import requests from '@/utils/requests';

/**
 * 创建服务
 * @param {*} data
 */
export function serviceAdd(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/service/add',
    method: 'post',
    data
  });
}

/**
 * 服务列表
 * @param {*} data
 */
export function serviceList(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/service/list',
    method: 'post',
    data
  });
}

/**
 * 修改服务
 * @param {*} data
 */
export function serviceModify(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/service/modify',
    method: 'post',
    data
  });
}

/**
 * 删除服务
 * @param {*} data
 */
export function serviceDelete(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/service/delete',
    method: 'post',
    data
  });
}

/**
 * 服务详情
 * @param {*} data
 */
export function serviceDetail(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/service/detail',
    method: 'post',
    data
  });
}

/**
 * Gitlab项目列表
 * @param {*} data
 */
export function gitlabProjectList(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/service/gitlabProjectList',
    method: 'post',
    data
  });
}

/**
 * Gitlab分支列表
 * @param {*} data
 */
export function gitlabBranchList(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/service/gitlabBranchList',
    method: 'post',
    data
  });
}

/**
 * 飞书群聊列表
 * @param {*} data
 */
export function feiShuChatList(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/service/chats',
    method: 'post',
    data
  });
}

/**
 * 命名空间列表
 * @param {*} data
 */
export function namespaceList(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/service/namespaceList',
    method: 'post',
    data
  });
}

/**
 * 查询服务环境信息列表
 * @param {*} data
 */
export function serviceEnvironment(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/service/environment',
    method: 'post',
    data
  });
}

/**
 * 批量删除服务接口
 * @param {*} data
 */
export function serviceBatchDelete(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/service/batchDelete',
    method: 'post',
    data
  });
}

/**
 * 批量编辑服务接口
 * @param {*} data
 */
export function serviceBatchModify(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/service/batchModify',
    method: 'post',
    data
  });
}

/**
 * 验证服务名称是否符合规范
 * @param {*} data
 */
export function validateServiceName(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/service/validateServiceName',
    method: 'post',
    data
  });
}

/**
 * 获取Dockerfile模板
 * @param {*} data
 */
export function getDockerfileTemplate(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/service/dockerfile/templateQuery',
    method: 'post',
    data
  });
}

/**
 * 创建服务申请
 * @param {*} data
 */
export function serviceCreateApply(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/service/createApply',
    method: 'post',
    data
  });
}
